module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_height-3257c696a2a4e32719da4d2497048c4f.jpg";